/* Tyre Dispatch footer: the tab strip, and the rim sub-tabs inside the sizes
   panel. No dependencies. Safe to run twice -- it rebinds on the theme
   editor's section:load event so the tabs keep working while you edit. */
(function () {
  function pair(root, tabSel, panSel) {
    root.querySelectorAll(tabSel).forEach(function (t, i) {
      if (t.dataset.tdBound) return;
      t.dataset.tdBound = '1';
      t.addEventListener('click', function () {
        var tabs = root.querySelectorAll(tabSel),
            pans = root.querySelectorAll(panSel);
        tabs.forEach(function (x, n) {
          x.classList.toggle('is-on', n === i);
          if (x.hasAttribute('aria-selected')) x.setAttribute('aria-selected', n === i);
        });
        pans.forEach(function (x, n) { x.classList.toggle('is-on', n === i); });
      });
    });
  }

  function bind(scope) {
    (scope || document).querySelectorAll('.ft-tabs').forEach(function (w) {
      pair(w, '.sf-tab', '.ftp');
    });
    (scope || document).querySelectorAll('.rz').forEach(function (w) {
      pair(w, '.rz-tab', '.rz-pan');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
}());
